import { addStyles } from 'ethcss'
import { textSizes } from 'theme/media'
import { IStyles } from '../../../theme'

const deviceSettingsOnlineOfflineMode: IStyles = {
    title: {
        fontSize: textSizes.normal,
    },
    switchWrapper: {
        display: 'flex',
    },
    switchCaption: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 14,

        span: {
            marginRight: 6,
        },
    },
}

addStyles(deviceSettingsOnlineOfflineMode)
export default deviceSettingsOnlineOfflineMode
